import { render, staticRenderFns } from "./CompareHistoryTableRow.vue?vue&type=template&id=63ab11ca"
import script from "./CompareHistoryTableRow.vue?vue&type=script&lang=js"
export * from "./CompareHistoryTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports